import * as ReactService from "@intech/react-service";

class Log extends ReactService.BaseService {
  constructor() {
    super("Log");
  }

  CriarLog = (numFuncionalidade: number) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `CriarLog/${numFuncionalidade}`);

}

export const LogService = new Log();
